/**
 * Returns a palette color for a 0-100 deal score.
 * #FF495C (low) → #256EFF (mid) → #3DDC97 (high)
 */
const getScoreColor = (score) => {
  if (score >= 70) return "#3DDC97";
  if (score >= 40) return "#256EFF";
  return "#FF495C";
};

export default getScoreColor;
